import { queryClient } from "@/lib/queryClient";

/**
 * Reconhece o 503 de manutenção (mesmo formato do MaintenanceMiddleware e de
 * POST /auth/login|refresh — contrato Front, docs/superpowers/plans/
 * 2026-09-28-manutencao-no-login.md) e invalida a query de status na hora,
 * sem esperar os 30s do polling do MaintenanceProvider (mesma queryKey que
 * ele usa). Nada de logout — manutenção não é sessão inválida.
 *
 * Achado BAIXO (revisão de segurança, 28/09/2026, item 10): existiam DUAS
 * instâncias axios no projeto (`@/services/api`, usada por ~130 arquivos, e
 * `@/lib/apiClient`, usada por ~10) — só a primeira tinha este interceptor.
 * Extraído aqui pra ser chamado pelas duas, sem duplicar a lógica.
 *
 * Achado (sugestão, item 12): uma rajada de 503 simultâneos (várias chamadas
 * em paralelo, todas vendo a manutenção pela primeira vez) disparava uma
 * `invalidateQueries` por chamada — throttle de 2s evita isso.
 */
const THROTTLE_MS = 2000;
let ultimaInvalidacaoEm = 0;

interface ErroComRespostaDeManutencao {
  response?: {
    status?: number;
    data?: { maintenance?: boolean };
  };
}

export function invalidarStatusSeForManutencao(error: unknown): void {
  const erro = error as ErroComRespostaDeManutencao | undefined;
  if (erro?.response?.status !== 503 || erro.response?.data?.maintenance !== true) {
    return;
  }

  const agora = Date.now();
  if (agora - ultimaInvalidacaoEm < THROTTLE_MS) return;
  ultimaInvalidacaoEm = agora;

  // cancelRefetch:false — não cancela um refetch já em andamento pra
  // disparar outro igual; deixa o React Query dedupar.
  queryClient.invalidateQueries({ queryKey: ["maintenance-status"] }, { cancelRefetch: false });
}

/** Só pra teste resetar o throttle entre casos — nunca chamar em código de produção. */
export function _resetarThrottleParaTeste(): void {
  ultimaInvalidacaoEm = 0;
}
